export enum Role { 
    Admin = "Admin",
    ReadOnly = "ReadOnly",
    Builder = "Builder"
} 